import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { JaHeaderJaIcon, LogoPlus, LogoSection } from './styled';
import { appType } from '@/shared/config';
import { AppType } from '@/shared/types/app';
import { LogoIcon } from '@/shared/assets/icons';
export const Logo = memo(() => {
    const handleOpenJASite = () => {
        window.open('https://www.jewishagency.org', '_blank');
    };
    const handleOpenRLSite = () => {
        window.open('https://realush.com', '_blank');
    };
    return (_jsxs(LogoSection, { children: [appType === AppType.JA && (_jsxs(_Fragment, { children: [_jsx(JaHeaderJaIcon, { onClick: handleOpenJASite, style: { cursor: 'pointer' } }), _jsx(LogoPlus, { children: "+" })] })), _jsx(LogoIcon, { color: "primary", onClick: appType === AppType.JA ? handleOpenRLSite : undefined, style: appType === AppType.JA ? { cursor: 'pointer' } : {} })] }));
});
